import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AlertTrendKPIDataAssetDashboard } from '../services/getAlertTrendAssetKPIData'

export interface AlertTrendAseetKPIDataState {
  isLoading: boolean
  errorMessage: string | null
  AlertTrendKPIDataAssetDashboard: AlertTrendKPIDataAssetDashboard | null
  httpStatus: number | null
}

// Initial state of the slice
const initialState: AlertTrendAseetKPIDataState = {
  AlertTrendKPIDataAssetDashboard: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const AlertTrendKPIDataAssetDataState = createSlice({
  name: 'AlertTrendKPIDataAssetDataState',
  initialState,
  reducers: {
    AlertTrendKPIDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        AlertTrendKPIDataAssetDashboard: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    AlertTrendKPIDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        AlertTrendKPIDataAssetDashboard: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    AlertTrendKPIDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        AlertTrendKPIDataAssetDashboard: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  AlertTrendKPIDataLoadingAction,
  AlertTrendKPIDataUpdateAction,
  AlertTrendKPIDataErrorAction
} = AlertTrendKPIDataAssetDataState.actions

export default AlertTrendKPIDataAssetDataState.reducer
